(() => {
  const header = document.querySelector('.site-header');
  const shop = document.querySelector('[data-shop-navigation]');
  const search = document.querySelector('[data-header-search]');
  const desktop = window.matchMedia('(min-width: 1181px) and (hover: hover)');
  if (shop) {
    let timer;
    shop.querySelector('summary').addEventListener('click', event => { if (desktop.matches) { event.preventDefault(); shop.open = true; } });
    shop.addEventListener('pointerenter', () => { if (desktop.matches) { clearTimeout(timer); shop.open = true; if (search) search.open = false; } });
    shop.addEventListener('pointerleave', () => { if (desktop.matches) timer = setTimeout(() => { if (!shop.contains(document.activeElement)) shop.open = false; }, 180); });
  }
  document.querySelectorAll('.category-branch').forEach(branch => {
    branch.querySelector('summary').addEventListener('click', event => { if (desktop.matches && !branch.closest('[data-drawer]')) { event.preventDefault(); branch.open = true; } });
    branch.addEventListener('pointerenter', () => { if (desktop.matches && !branch.closest('[data-drawer]')) branch.open = true; });
  });
  document.addEventListener('click', event => {
    if (header && !header.contains(event.target)) { if (shop) shop.open = false; if (search) search.open = false; }
  });
  if (!search) return;
  const form = search.querySelector('form');
  const input = search.querySelector('input[type="search"]');
  const results = search.querySelector('[data-search-results]');
  const status = search.querySelector('[data-search-status]');
  const config = search.querySelector('[data-live-search]').dataset;
  let timer, controller, version = 0;
  const close = () => { search.open = false; search.querySelector('summary').focus(); };
  search.querySelector('[data-close-search]').addEventListener('click', close);
  search.addEventListener('toggle', () => { if (search.open) { if (shop) shop.open = false; input.focus(); } });
  async function lookup() {
    const query = input.value.trim();
    const current = ++version;
    if (controller) controller.abort();
    results.replaceChildren();
    if (!query) { status.textContent = ''; return; }
    controller = new AbortController();
    const signal = controller.signal;
    status.textContent = config.loading;
    const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '8', section_id: 'predictive-search' });
    try {
      const response = await fetch(`${config.endpoint}?${params}`, { signal });
      if (!response.ok) throw new Error('predictive-search');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-predictive-results]');
      if (!content) throw new Error('missing-results');
      if (current !== version) return;
      results.append(content);
      status.textContent = '';
    } catch (error) {
      if (error.name === 'AbortError' || current !== version) return;
      try {
        const fallbackParams = new URLSearchParams({q:query,type:'product',section_id:'main-search'});
        const response = await fetch(`${config.fallback}?${fallbackParams}`, {signal});
        if (!response.ok) throw new Error('search');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = Array.from(doc.querySelectorAll('.product-card')).slice(0, 8);
        if (current !== version) return;
        const list = document.createElement('ul'); list.className = 'live-search-products';
        cards.forEach(card => {
          const li = document.createElement('li'); const link = document.createElement('a');
          link.href = card.getAttribute('href');
          const image = card.querySelector('img'); if (image) link.append(image.cloneNode(true));
          const text = document.createElement('span'); const title = document.createElement('strong');
          title.textContent = card.querySelector('.product-title').textContent; text.append(title);
          const price = card.querySelector('.price'); if (price) text.append(price.cloneNode(true));
          link.append(text); li.append(link); list.append(li);
        });
        results.replaceChildren(list); status.textContent = cards.length ? '' : config.empty;
      } catch (fallbackError) { if (fallbackError.name !== 'AbortError' && current === version) status.textContent = config.error; }
    }
  }
  input.addEventListener('input', () => { clearTimeout(timer); version++; if (controller) controller.abort(); timer = setTimeout(lookup, 220); });
  form.addEventListener('submit', event => { event.preventDefault(); clearTimeout(timer); lookup(); });
  input.addEventListener('keydown', event => { if (event.key === 'ArrowDown') { const first = results.querySelector('a'); if (first) { event.preventDefault(); first.focus(); } } });
  results.addEventListener('keydown', event => {
    const links = Array.from(results.querySelectorAll('a')); const index = links.indexOf(document.activeElement);
    if (event.key === 'ArrowDown') { event.preventDefault(); links[Math.min(index + 1, links.length - 1)]?.focus(); }
    if (event.key === 'ArrowUp') { event.preventDefault(); if (index <= 0) input.focus(); else links[index - 1].focus(); }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { if (search.open) close(); if (shop && shop.open) { shop.open = false; shop.querySelector('summary').focus(); } } });
})();
